/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  order.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {SelectGoodsOptionsDto} from "@/api/commonConfig";

const order = {
  state: {
    selectList: [], // 代客下单选择商品页选种商品缓存数据
    messageUnreadNo: null, // 未读消息条数
    orderFromPage: '0', // 订单模块  是否是从原生的消息详情页面进去  用于解决从消息模块进去订单模块时右上角返回首页问题
  },
  mutations: {
    SET_SELECT_LIST: (state: any, selectList: SelectGoodsOptionsDto[]) => {
      state.selectList = selectList
    },
    SET_MESSAGE_NO: (state: any, messageUnreadNo: number | null) => {
      state.messageUnreadNo = messageUnreadNo
    },
    SET_ORDER_FROMPAGE: (state: any, formPage: number | string) => {
      state.orderFromPage = formPage
    }
  },
  actions: {
    setSelectList({ commit }: any, selectList: SelectGoodsOptionsDto[]) {
      commit("SET_SELECT_LIST", selectList);
    },
    setMessageNo({ commit }: any, messageUnreadNo: number | null[]) {
      commit("SET_MESSAGE_NO", messageUnreadNo);
    },
    setOrderFromPage({ commit }: any, formPage: number | null[]) {
      commit("SET_ORDER_FROMPAGE", formPage);
    }
  },
};

export default order;
